import React, { useState, useEffect } from 'react'
import { Container, Card, Alert, Spinner, Button, Row, Col } from 'react-bootstrap'
import d_log from 'loglevel'
import api_utils from '../lib/api_utils'

function Recents() {
  const [recents, setRecents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    // Placeholder for future backend integration
    d_log.debug('Recents page loaded - backend integration pending')
    setLoading(false)
  }, [])

  const handleReload = () => {
    d_log.debug('User requested reload of recents')
    setLoading(true)
    setError(null)

    // TODO: Replace with actual backend call
    // const recentsUrl = `${import.meta.env.VITE_SERVICE_URL}/recents`
    // const headers = api_utils.form_auth_headers()
    // const response = await api_utils.call_backend_url(recentsUrl, headers)

    setTimeout(() => {
      setLoading(false)
    }, 500)
  }

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading recent items...</span>
        </Spinner>
        <p className="mt-3">Loading recent items...</p>
      </Container>
    )
  }

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h2>Recent Items</h2>
          <p className="text-muted mb-0">Your recently accessed documents and conversations</p>
        </div>
        <Button
          variant="outline-primary"
          onClick={handleReload}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Reloading...
            </>
          ) : (
            <>
              🔄 Reload
            </>
          )}
        </Button>
      </div>

      {error && (
        <Alert variant="danger" className="mt-3">
          <Alert.Heading>Error Loading Recent Items</Alert.Heading>
          <p>{error}</p>
        </Alert>
      )}

      <Card className="mt-4">
        <Card.Header>
          <h5>Recent Activity</h5>
        </Card.Header>
        <Card.Body>
          {recents.length === 0 ? (
            <div className="text-center py-5">
              <div className="text-muted mb-3">
                <i className="fas fa-clock" style={{ fontSize: '3rem', opacity: 0.3 }}></i>
              </div>
              <h5 className="text-muted">No Recent Items</h5>
              <p className="text-muted">
                Your recently accessed documents and conversations will appear here.
              </p>
              <Alert variant="info" className="mt-4">
                <Alert.Heading>Coming Soon!</Alert.Heading>
                <p className="mb-0">
                  This page will display your recent documents, chat conversations, and other activities
                  once connected to the backend service.
                </p>
              </Alert>
            </div>
          ) : (
            <Row>
              {recents.map((item, index) => (
                <Col md={6} lg={4} key={index} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Title>{item.title}</Card.Title>
                      <Card.Text>{item.description}</Card.Text>
                      <small className="text-muted">
                        {new Date(item.timestamp).toLocaleString()}
                      </small>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Card.Body>
      </Card>
    </Container>
  )
}

export default Recents